import { useCallback } from "react";
import type { Editor } from "grapesjs";

const downloadTextFile = (filename: string, content: string, mime: string) => {
    const blob = new Blob([content], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};

export function useJsonExport(editorRef: React.RefObject<Editor>, projectName: string, templateId: string) {
    return useCallback(() => {
        const editor = editorRef.current;
        if (!editor) return;

        const json = JSON.stringify(
            { projectName, templateId, data: editor.getProjectData() },
            null,
            2,
        );

        downloadTextFile(`${projectName}.json`, json, "application/json");
    }, [editorRef, projectName, templateId]);
}
